import Routes from './RoutesConfig';
/**
 *
 */
var RouteUtils = /** @class */ (function () {
    /**
     *
     */
    function RouteUtils() {
        this._routes = Object.keys(Routes).map(function (key) { return Routes[key]; });
    }
    /**
     *
     * @param path
     * @return {*}
     */
    RouteUtils.prototype.getVariables = function (path) {
        if (path === void 0) { path = null; }
        path = path ? path : window.location.pathname;
        var route = this.getRoute(path);
        return route ? route.getVariables(path) : null;
    };
    /**
     *
     * @param path
     * @return {*}
     */
    RouteUtils.prototype.getRoute = function (path) {
        var _this = this;
        if (path == null) {
            return null;
        }
        var segments = path.toLowerCase().split('/');
        this.cleanupSegments(segments);
        var result = null;
        // Check all routes for match
        this._routes.forEach(function (route) {
            var routeSegments = route.path.split('/');
            _this.cleanupSegments(routeSegments);
            // Can only match if equal number of segments
            if (routeSegments.length === segments.length) {
                var isMatch_1 = true;
                // Compare segments
                routeSegments.forEach(function (routeSegment, index) {
                    // Ignore if parameter
                    if (routeSegment.indexOf(':') < 0) {
                        if (routeSegment !== segments[index]) {
                            isMatch_1 = false;
                            return isMatch_1;
                        }
                    }
                });
                // Set result if match
                if (isMatch_1) {
                    result = route;
                    // Stop forEach loop
                    return false;
                }
            }
        });
        return result;
    };
    /**
     *
     * @param segments
     */
    RouteUtils.prototype.cleanupSegments = function (segments) {
        if (segments[segments.length - 1] === '') {
            segments.pop();
        }
    };
    return RouteUtils;
}());
var routeUtils = new RouteUtils();
export default routeUtils;
